"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZInvitedBySelect = void 0;
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZInvitedBySelect = zodSchemas_generated_1.zodSelectInvitedBy
    .pick({
    inviteeId: true,
    inviterId: true,
    createdAt: true,
    bonusScheme: true,
    status: true,
    inviterGracePeriodExpiresAt: true,
    inviteeGracePeriodExpiresAt: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectInvitedBy.shape, {
    createdAt: zod_1.z.coerce.date(),
    inviterGracePeriodExpiresAt: zod_1.z.coerce.date().nullable(),
    inviteeGracePeriodExpiresAt: zod_1.z.coerce.date().nullable(),
}));
//# sourceMappingURL=models.js.map